<div (click)="handleClick(fileupload)"  [pTooltip]="name ? name : 'Anexar Recibo/NF'" tooltipPosition="bottom">
    <span>{{name ? name : 'Anexar Recibo/NF' }}</span>
    <split-icon name="cloud-upload"></split-icon>
</div>

<input accept=".pdf,.png,.jpg,.jpeg" style="display: none;" class="file-input" type="file" #fileupload>